<template>
    <div>
      <!-- <button
        v-if="tempTokenPaypal !== undefined "
        class="btn btn-primary btnPaypal px-5 py-3 w-100 fw-bold"
        @click="pay"
        id="payPaypal"
      >
          Pagar con Paypal
          <span v-show="is_loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </button>
      <button 
        v-else
        class="btn btn-primary btnPaypal px-5 py-3 w-100 fw-bold"
        @click="setupTokenPaypal">
        Iniciar Sesión en Paypal
        <span v-show="is_loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </button>
      <p class="pt-3">Tu orden ser&aacute; enviada una vez que tu pago sea confirmado.</p> -->
    </div>
  </template>
    
    <script>
    const axios = require("axios");
  export default {
    props: ["tempTokenPaypal","addressData", "products", "codeCoupon"],
    data() {
      return {
        api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
        local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
        userId: null,
        address: null,
        addressId: null,
        urlPaypal: null,
        is_loading: false,
        tokenPaypal: ""
      };
    },
    created() {
      this.userId = $cookies.get("uidmmkg");
      this.address = this.addressData;
      this.addressId = this.addressData.id;
      console.log(parseInt(this.userId));
      console.log("paypal token: ", this.tempTokenPaypal);
      console.log("paypal address: ", this.address);
      console.log("paypal: address_id", this.addressId);
      console.log("paypal products: ", this.products);
      console.log("paypal cupon: ", this.codeCoupon);
      localStorage.setItem('temporalAddressPaypal', JSON.stringify(this.address));
      localStorage.setItem('temporalAddressIdPaypal', JSON.stringify(this.addressId));
      localStorage.setItem('temporalProductsPaypal', JSON.stringify(this.products));
      localStorage.setItem('temporalCodeCouponPaypal', JSON.stringify(this.codeCoupon));

      if(this.tempTokenPaypal !== undefined){
        this.saveTokenPaypal();
      }
    },
    methods: {
      async setupTokenPaypal() {
        this.is_loading = true;
        console.log("configurando token paypal");
        axios({
          method: "POST",
          url: this.api_url + "/paypal/setup-token",
          data: {
            user_id: this.userId,
            address_id: this.addressId,
            return_url: this.local_url + "checkout",
            cancel_url: this.local_url,
            // return_url: "http://localhost:8080/checkout",
            // cancel_url: "http://localhost:8080",
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("utoken"),
          },
        })
          .then((res) => {
            console.info("Configurando Paypal", res);
            if (res.data.status) {
                this.urlPaypal =  res.data.url;
                window.location.href = res.data.url;
                this.is_loading = false;
            } else {
              this.$snotify.error(res.data.message);
              this.is_loading = false;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      },
      saveTokenPaypal(){
        console.log("resp de paypal", this.urlPaypal);
        axios({
          method: "POST",
          url: this.api_url + "/paypal/save-payment-token",
          data: {
            user_id: this.userId,
            token: this.tempTokenPaypal,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("utoken"),
          },
        })
          .then((res) => {
            console.info("Guardando token temporal de paypal: y obteniendo otro ", res);
            if (res.data.status) {
              console.log(res.data.message);
              this.tokenPaypal = res.data.paypal_payment_token;
            } else {
              this.$snotify.error(res.data.message);
              this.is_loading = false;
            }
          })
          .catch((error) => {
            this.$snotify.error(error);
            console.error(error);
            this.$emit('statusLoading', false)
          });
      },
      pay () {
        this.is_loading = true;
        console.log("pagando por paypal  con token: ", this.tokenPaypal);
        axios({
          method: "POST",
          url: this.api_url + "/paypal/payment",
          data: {
            paypal_payment_token: this.tokenPaypal,
            user_id: this.userId,
            address_id: this.addressId,
            code: this.codeCoupon,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("utoken"),
          },
        })
        .then((res) => {
            console.info("Pagando con paypal: ", res);
            if (res.data.status) {
                console.log("respuesta pago:");
                console.log(res.data.data.paymentData.order);
                this.is_loading = false;
                localStorage.setItem('metodoPago', "paypal");
                this.$router.push({name: "ThankYouPage", params: { order: res.data.data.paymentData.order}});
            } else {
                this.$snotify.error(res.data.message);
            }
        })
        .catch((error) => {
            this.$snotify.error(error);
            console.error(error);
            this.$emit('statusLoading', false)
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .btnPaypal{
      background-color:#142c8f !important;
      font-weight: 900;
  }
  .btnPaypal:hover{
      background-color:#142c8f !important;
      font-weight: 900;
  }
  #stripe-payment-element-errors{
      margin:50px 0 !important; 
  }
  
  </style>